import { injectIntl } from "react-intl";
import { useState, useRef, useEffect } from "react";
import apiService from "src/services/api.service";

const EditCreative = (props) => {
  const textareaRef = useRef(null);
  const [creative, setCreative] = useState(props.creative);

  useEffect(() => {
    setCreative(props.creative);
  }, [props.creative]);

  useEffect(() => {
    if (textareaRef.current && props?.type === "SMS") {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [creative?.note, props?.type]);

  const createUpdateCreative = () => {
    apiService.updateCreative(creative).then(() => {
      props.onUpdateSuccess?.();
    });
  };

  const handleInput = (param, value) => {
    setCreative({ ...creative, [param]: value });
  };

  return (
    <div className="NewStrategyModalOverlay z-[99]">
      <div className="NewStrategyModal">
        <div className="flex flex-col gap-3 items-start self-stretch">
          <div className={"w-full flex justify-between"}>
            <div className={"NewCreative"}>
              <img
                alt={"Logo"}
                src={"/media/icons/editIcon.svg"}
                className={"w-[18px] h-[18px]"}
              />
              Edit Creative
            </div>
            <button className={"CloseIconButton"} onClick={props.closeModal}>
              <img
                alt={"Logo"}
                src={"/media/icons/closeIcon.svg"}
                className={"w-5 h-5"}
              />
            </button>
          </div>
          <div className="flex items-start justify-center gap-[8px] rounded-lg bg-[#F6F6F9] p-[6px]">
            <img
              alt={"Logo"}
              src={"/media/icons/layout-alt-03.svg"}
              className={"w-[14px] h-[14px]"}
            />
            <div
              className="text-[12px] font-medium leading-[18px] text-[#8185A8]"
              style={{ fontFamily: "Inter" }}
            >
              Offer Name:
            </div>
            <div
              className="text-[12px] font-semibold leading-[18px] text-[#15151F]"
              style={{ fontFamily: "Inter" }}
            >
              {creative?.offer_name}
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col gap-4 items-start self-stretch">
          <div className="h-[1px] self-stretch bg-[#E5E7F0]"></div>
          <div className={"NewStrategyInputSection"}>
            <div className={"NewStrategyInputTitle"}>
              {props?.type} Creative Name
            </div>
            <input
              className={"NewStrategyInput"}
              type="text"
              placeholder="Enter"
              onChange={(e) => handleInput("name", e.target.value)}
              value={creative?.name}
            />
          </div>
          <div
            className={
              props?.type === "SMS"
                ? "NewStrategyInputSection hasTextarea"
                : "NewStrategyInputSection"
            }
          >
            <div className={"NewStrategyInputTitle"}>
              {props?.type === "Email" ? "Creative Note" : "Message"}
              {props?.type === "Email" && (
                <span className={"Optional"}>(Optional)</span>
              )}
            </div>
            {props?.type === "SMS" ? (
              <textarea
                ref={textareaRef}
                className={"NewStrategyTextarea"}
                placeholder="Enter"
                onChange={(e) => handleInput("note", e.target.value)}
                value={creative?.note}
                rows={4}
              />
            ) : (
              <input
                className={"NewStrategyInput"}
                type="text"
                placeholder="Enter"
                onChange={(e) => handleInput("note", e.target.value)}
                value={creative?.note}
              />
            )}
          </div>
          <div className="h-[1px] self-stretch bg-[#E5E7F0]"></div>
          <div className="modal-actions">
            <button
              type="button"
              onClick={props.closeModal}
              className="CloseButton"
            >
              Close
            </button>
            <button
              type="submit"
              className="CreateButton"
              onClick={createUpdateCreative}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(EditCreative);
